import styled from 'styled-components'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import colors from '../../../configuration/colors'
import HourglassDove from '../../../static/images/icons/hourglass_dove.svg'

const Container = styled.div`
  width: 660px;
  border-radius: 20px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  overflow: auto;
  background: #f8f8f8;
  margin-bottom: 30px;
  height: 650px;
`

const ErrorContainer = styled.div`
  width: 519px;
  border-radius: 20px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  overflow: auto;
  background: ${colors.white};
  margin-bottom: 30px;
`

const ModalTop = styled.div`
  padding: 23px;
  position: relative;
  border-bottom: 1px solid #dedfe0;
  background-color: ${colors.white} .target-date {
    font-weight: 500;
    color: ${colors.dove};
    background: 0 50% url(${HourglassDove}) no-repeat;
  }
`

const ModalBody = styled(FlexAlignCenter)`
  padding: 24px 0 31px;
  background: #f8f8f8;
  justify-content: center;
  flex-direction: column;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  max-height: 90%;
  text-align: left;
`

const QuestsContainer = styled.div`
  width: 541px;
  border: 1px solid ${colors.ash};
  border-radius: 20px;
  background-color: ${colors.white};
  padding: 23px 18px 15px 18px;
  margin-bottom: 14px;

  .__react_component_tooltip {
    padding: 0 !important;
    background: ${props => props.theme.footerBackground} !important;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
    border-radius: 10px !important;
    border: none;

    &.place-left {
      &:before {
        border-left: 8px solid ${colors.smoke};
      }

      &:after {
        border-left-color: ${colors.white} !important;
      }
    }

    &.place-top {
      &:before {
        border-top: 8px solid ${colors.smoke};
      }

      &:after {
        border-top-color: ${colors.white};
      }
    }

    &.place-bottom {
      &:before {
        border-bottom: 8px solid ${colors.smoke};
      }

      &:after {
        border-bottom-color: ${colors.white};
      }
    }

    &.place-right {
      &:before {
        border-right: 8px solid ${colors.smoke};
      }

      &:after {
        border-right-color: ${colors.white};
      }
    }
  }
`

const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`

const HeaderBlock = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`

const CancelButton = styled.button`
  box-sizing: border-box;
  padding: 10px 0;
  width: 126px;
  border: 1px solid #999999;
  border-radius: 20px;
  font-size: 16px;
  color: #444444;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin-right: 24px;
  &:hover {
    border: 1px solid ${colors.black};
    color: ${colors.charcoal2};
    box-shadow: 0 6px 8px 0.15px rgba(0, 0, 0, 0.1);
  }
`

const SaveButton = styled.button`
  box-sizing: border-box;
  padding: 10px 0;
  width: 126px;
  border: 1px solid ${colors.oeYellow};
  border-radius: 20px;
  background: linear-gradient(
    270deg,
    ${colors.amber} 0%,
    ${colors.citron} 100%
  );
  box-shadow: 0 4px 2.85px 0.15px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  color: ${colors.charcoal2};
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  margin-right: 24px;

  &:disabled {
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none;
  }

  &:disabled:hover {
    background: ${colors.rock};
    border: 1px solid ${colors.rock};
    color: ${colors.white};
    box-shadow: none;
  }
  &:hover {
    background: linear-gradient(-45deg, ${colors.amberLite}, ${colors.turbo});
  }
`

const Header = styled.h1`
  color: ${colors.victoria};
  font-family: Montserrat;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 27px;
  margin-left: 6px;
`

const ModalQuestBlock = styled.div`
  display: flex;
  padding: 10px 23px;
  border-bottom: 1px solid ${colors.ash};
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
`

const QuestImage = styled.img`
  border-radius: 50%;
  border: 1px solid ${colors.rock};
  width: 31px;
  height: 31px;
`

const QuestHeader = styled.div`
  color: ${colors.victoria};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  margin-left: 6px;
`

const ModalArtifactBlock = styled.div`
  display: flex;
  padding: 15px 23px 0 23px;
  border-bottom: 1px solid ${colors.ash};
  align-items: center;
  align-content: center;
  background-color: ${colors.white};
`

const CalendarBlock = styled.div`
  background-color: #f9f9f9;
  height: 400px;
  padding: 15px 23px;
`

const ApplyToAll = styled.p`
  color: ${colors.dove};
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
`
const Checkbox = styled.div`
  margin-bottom: 0px;
  width: 20px;
  height: 20px;
  border: 1px solid;
  border-radius: 5px;
  position: absolute;
`

const CheckboxBlock = styled.div`
  position: relative;
  top: -10px;
  margin-right: 30px;
`

const CheckboxIcon = styled.img`
    width: 12px
    height: 10px;
    position: absolute;
    left: 4px;
    top: 4px;
`
const ErrorHeader = styled.h1`
  color: ${colors.victoria};
  font-family: 'Lato', sans-serif;
  font-size: 24px;
  font-weight: 500;
`

const ErrorMessage = styled.div`
  color: ${colors.charcoal4};
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20.8px;
  text-align: center;
  padding: 0 80px;
`

const ErrorButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 25px 0;
  border-top: 1px solid #eeeeee;
  padding-top: 22px;
`

const ErrorModalTop = styled.div`
  padding: 23px 23px 0 23px;
  position: relative;
  border-bottom: 1px solid #dedfe0;
  background-color: ${colors.white};

  .target-date {
    font-weight: 500;
    color: ${colors.dove};
    background: 0 50% url(${HourglassDove}) no-repeat;
  }
`

export {
  Container,
  ModalTop,
  ModalQuestBlock,
  ModalBody,
  QuestsContainer,
  QuestImage,
  ButtonBlock,
  HeaderBlock,
  CancelButton,
  SaveButton,
  Header,
  QuestHeader,
  ModalArtifactBlock,
  CalendarBlock,
  ApplyToAll,
  Checkbox,
  CheckboxBlock,
  CheckboxIcon,
  ErrorMessage,
  ErrorButtonBlock,
  ErrorContainer,
  ErrorHeader,
  ErrorModalTop
}
